module.exports = __webpack_public_path__ + "assets/08f8be8e09d564188734b17538127cd3.png";